import * as THREE from 'three';
import rendersize from '../data/renderConfig.json'

//加载射线点击

const raycaster = new THREE.Raycaster();
const pointer = new THREE.Vector2();
// let bigSize = {
//   offsetx: 0.12,
//   offsety: 0.23,
//   xyADD: 1.5,
//   cclick: 1.5//threejs渲染的canvas放大1.5 这里就反而要根据坐标 除以1.5倍系数从而还原点击初始化
// }

let bigSize =rendersize
function onPointerMove(event) {
  let offxy = {
    x: window.innerWidth * bigSize.offsetx/bigSize.xyADD,
    y: window.innerHeight * bigSize.offsety/bigSize.xyADD ,
  }


  // 将鼠标位置归一化为设备坐标。x 和 y 方向的取值范围是 (-1 to +1)
  pointer.x = ((event.clientX / bigSize.cclick+ offxy.x )/ window.innerWidth) * 2 - 1;
  pointer.y = - ((event.clientY / bigSize.cclick+ offxy.y )/ window.innerHeight) * 2 + 1;


}
const resizeP=()=>{
  console.log(pointer);
}

// window.addEventListener('resize', resizeP);//添加窗口改变相机刷新时间


window.addEventListener('pointermove', onPointerMove);

export { raycaster, pointer }